<template>
  <section>
    <div class="login-form-wrapper">
      <div class="login-wrapper">
        <h2>Welcome</h2>
      </div>
      <div class="button-wrapper">
        <button type="button" class="sso-button" @click="onClickSso">
          Sign in with SSO
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from "vue-router"

const router = useRouter()
const emit = defineEmits(["set-user"])

function onClickSso() {
  const baseUrl = process.env?.VUE_APP_API_BASE_URL || "http://localhost:3000/api"
  const ssoLoginUrl = `${baseUrl.replace(/\/$/, "")}/sso/login`
  window.location.href = ssoLoginUrl
}
</script>

<style scoped>
section {
  width: 20em;
  margin: 5% auto 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

button {
  background-color: #810000;
  font-family: Avenir;
  font-weight: bold;
  font-size: 1.25rem;
  color: white;
  width: 100%;
  border-radius: 6px;
  padding: 0.75em;
  transition: all 0.2s, box-shadow 0.08s ease-in;
  cursor: pointer;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.33) 1px 1px 1px;
}

button:hover {
  background-color: #740000;
  box-shadow: rgba(0, 0, 0, 0.45) 1px 1px 3px;
}

button:focus {
  box-shadow: rgba(93, 50, 50, 0.1) 0 0 0 1px inset,
    rgba(93, 50, 50, 0.2) 0 6px 15px 0, rgba(0, 0, 0, 0.1) 0 2px 2px 0,
    rgba(211, 50, 50, 0.3) 0 0 0 4px;
}

.login-form-wrapper {
  padding: 1.5rem;
}

.login-wrapper {
  text-align: center;
  margin-bottom: 2rem;
}

.button-wrapper {
  margin-top: 0.5rem;
}
</style>
